import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_API_CLIENTS_REQUEST = 'LOAD_API_CLIENTS_REQUEST';
export const LOAD_API_CLIENTS_SUCCESS = 'LOAD_API_CLIENTS_SUCCESS';
export const LOAD_API_CLIENTS_FAIL = 'LOAD_API_CLIENTS_FAIL';

export const LOAD_RESTRICTED_CLIENTS_REQUEST = 'LOAD_RESTRICTED_CLIENTS_REQUEST';
export const LOAD_RESTRICTED_CLIENTS_SUCCESS = 'LOAD_RESTRICTED_CLIENTS_SUCCESS';
export const LOAD_RESTRICTED_CLIENTS_FAIL = 'LOAD_RESTRICTED_CLIENTS_FAIL';

export const POST_API_CLIENTS_REQUEST = 'POST_API_CLIENTS_REQUEST';
export const POST_API_CLIENTS_SUCCESS = 'POST_API_CLIENTS_SUCCESS';
export const POST_API_CLIENTS_FAIL = 'POST_API_CLIENTS_FAIL';

export const DELETE_API_CLIENTS_REQUEST = 'DELETE_API_CLIENTS_REQUEST';
export const DELETE_API_CLIENTS_SUCCESS = 'DELETE_API_CLIENTS_SUCCESS';
export const DELETE_API_CLIENTS_FAIL = 'DELETE_API_CLIENTS_FAIL';

export const PUT_API_CLIENTS_SECRET_REQUEST = 'PUT_API_CLIENTS_SECRET_REQUEST';
export const PUT_API_CLIENTS_SECRET_SUCCESS = 'PUT_API_CLIENTS_SECRET_SUCCESS';
export const PUT_API_CLIENTS_SECRET_FAIL = 'PUT_API_CLIENTS_SECRET_FAIL';

const loadApiClientsRequest = () => ({ type: LOAD_API_CLIENTS_REQUEST });
const loadApiClientsSuccess = (payload) => ({ type: LOAD_API_CLIENTS_SUCCESS, payload });
const loadApiClientsFail = () => ({ type: LOAD_API_CLIENTS_FAIL });

const postApiClientsRequest = () => ({ type: POST_API_CLIENTS_REQUEST });
const postApiClientsSuccess = (payload) => ({ type: POST_API_CLIENTS_SUCCESS, payload });
const postApiClientsFail = () => ({ type: POST_API_CLIENTS_FAIL });

const deleteApiClientsRequest = () => ({ type: DELETE_API_CLIENTS_REQUEST });
const deleteApiClientsSuccess = (payload) => ({ type: DELETE_API_CLIENTS_SUCCESS, payload });
const deleteApiClientsFail = () => ({ type: DELETE_API_CLIENTS_FAIL });

const putApiClientsSecretRequest = () => ({ type: PUT_API_CLIENTS_SECRET_REQUEST });
const putApiClientsSecretSuccess = (payload) => ({ type: PUT_API_CLIENTS_SECRET_SUCCESS, payload });
const putApiClientsSecretFail = () => ({ type: PUT_API_CLIENTS_SECRET_FAIL });

export const loadApiClients = (params = {}) => (dispatch) => {
  dispatch(loadApiClientsRequest());
  return communicate({ url: 'ApiClients', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      dispatch(loadApiClientsSuccess(data.Data));
    })
    .catch((err) => {
      dispatch(loadApiClientsFail());
      toastrError(err);
    });
};

export const postApiClients = (params) => (dispatch) => {
  dispatch(postApiClientsRequest());
  return communicate({ url: 'ApiClients', method: 'post', data: params })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(postApiClientsSuccess(data.Data));
    })
    .catch((err) => {
      dispatch(postApiClientsFail());
      toastrError(err);
    });
};

export const deleteApiClients = (params) => (dispatch) => {
  dispatch(deleteApiClientsRequest());
  return communicate({ url: 'ApiClients', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(deleteApiClientsSuccess(params));
    })
    .catch((err) => {
      dispatch(deleteApiClientsFail());
      toastrError(err);
    });
};

export const putApiClientsSecret = (params) => (dispatch) => {
  dispatch(putApiClientsSecretRequest());
  return communicate({ url: 'ApiClients/Secret', method: 'put', data: params })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(putApiClientsSecretSuccess(data.Data));
    })
    .catch((err) => {
      dispatch(putApiClientsSecretFail());
      toastrError(err);
    });
};
